import React from 'react';
import PropTypes from 'prop-types';
import AHero from '../atoms/_atoms.hero';
import ABreadCrumb from '../atoms/_atoms.breadcrumb';

export default function MHero({
	img,
	currentPage,
	className,
	parents,
	children,
}) {
	return (
		<section className="m-hero">
			<AHero img={img} className={className} />
			<div className="breadCrumb">
				<ABreadCrumb
					currentPage={currentPage}
					parents={parents}
				/>
			</div>
			{children}
		</section>
	);
}

MHero.propTypes = {
	img: PropTypes.string.isRequired,
	currentPage: PropTypes.any.isRequired,
	className: PropTypes.string,
	parents: PropTypes.any,
	children: PropTypes.any,
};

MHero.defaultProps = {
	className: '',
	parents: undefined,
	children: undefined,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.hero.js